import { Database, Cloud, Boxes, ClipboardCheck } from "lucide-react";
import SectionHeading from "./SectionHeading";
import { useT } from "../i18n/useT";

const icons = [Database, Cloud, Boxes, ClipboardCheck];

export default function Services() {
  const t = useT();
  return (
    <section id="services" className="py-24 sm:py-28 border-t border-ink-800/60">
      <div className="container-page">
        <SectionHeading eyebrow={t.services.eyebrow} title={t.services.title} lede={t.services.lede} />
        <div className="mt-12 grid gap-4 sm:grid-cols-2">
          {t.services.items.map((s, i) => {
            const Icon = icons[i] ?? Database;
            return (
              <div
                key={s.title}
                className="group rounded-xl border border-ink-800 bg-ink-900/40 p-6 transition hover:border-ink-700 hover:bg-ink-900/70"
              >
                <Icon className="size-6 text-accent-500" />
                <h3 className="mt-4 text-lg font-semibold text-ink-50">{s.title}</h3>
                <p className="mt-2 text-sm text-ink-300 leading-relaxed">{s.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
